import React from "react";
import AboutDesktop from "../../assets/images/home-page/banner-desktop.png";
import { useNavigate } from "react-router-dom";

const ExploreSattva = () => {
  const navigate = useNavigate();
  return (
    <article className="md:min-h-[calc(100vh-200px)] flex flex-col items-center p-4 md:py-16 dark:bg-[#0F172A]">
      <section className="bg-gradient-to-br from-green-300 via-emerald-300 to-teal-300
          shadow-xl shadow-green-900/20 text-black lg:flex lg:items-center lg:justify-between lg:w-[80%] h-auto md:h-[calc(100vh-200px)] rounded-xl shadow-xl overflow-hidden">
        {/* Left Side: Text */}
        <div className="w-full lg:w-1/2 p-6 md:p-12 flex flex-col justify-center text-center lg:text-left space-y-4">
          <h3 className="text-lg md:text-3xl font-semibold text-black">
            Explore how Sattva enables your path to sustainable growth
          </h3>
          <p className="text-black opacity-80 md:text-base text-sm leading-relaxed">
            Sattva empowers organizations to integrate sustainability into core business strategy through intelligent ESG data management and risk insights. By simplifying the tracking of Scope 1, 2, and 3 emissions, identifying ESG risks across operations and supply chains, and enabling transparent reporting, Sattva helps businesses move beyond compliance toward long-term value creation. With data-driven clarity and actionable intelligence, organizations can make informed decisions, strengthen resilience, and grow responsibly in an evolving regulatory and stakeholder landscape.
          </p>
          <button className="mt-4 inline-flex items-center justify-center bg-white text-green-600 font-semibold px-6 py-3 rounded-full shadow-lg hover:bg-green-100 transition transform hover:-translate-y-1" onClick={()=>navigate('/contact')}>
            Book a demo <i className="uil uil-arrow-right ml-2"></i>
          </button>
        </div>

        {/* Right Side: Image */}
        <div className="w-full lg:w-1/2 flex items-center justify-center p-4 md:p-12">
          <img
            src={AboutDesktop}
            alt="Sattva Illustration"
            className="w-full h-auto rounded-lg object-contain shadow-lg"
          />
        </div>
      </section>
    </article>
  );
};

export default ExploreSattva;
